import { z } from "zod";

export const communityAssignmentCompletionSchema = z.object({
  completed_at: z.iso.datetime().nullable(),
  status: z.enum(["completed", "missing", "late"]).nullable(),
  user: z.object({
    image_url: z.string().nullable(),
    last_name: z.string(),
    name: z.string().nullable(),
  }),
});

export type CommunityAssignmentCompletion = z.infer<
  typeof communityAssignmentCompletionSchema
>;
